import {useWindowDimensions} from 'react-native';

import {space} from '../../design-system/tokens';

/**
 * Figma breakpoints for the Header/Footer redesign (file IhAQZ4QmxWw2P3ZfjXAkEn):
 * mobile 320–1023, tablet 1024–1439, desktop 1440–1919, wide 1920+.
 *
 * SHORTCUT: header-local (Q17). Code breaks at 768 / 1200 (app/constants/ScreenDimensionsConfig.ts,
 * left untouched). The DIS-1859 redline's tokenGaps verdict (a local DIS-1859 artifact, not a
 * file in this repo): "deliberate code deviation: code uses 768 / 1200". Upgrade path: a
 * DIS-1735 decision on one breakpoint set, then delete this file.
 */
export const breakpoints = Object.freeze({
  mobileMax: 1023,
  tabletMin: 1024,
  desktopMin: 1440,
  wideMin: 1920,
});

/**
 * SHORTCUT: layout literals with no token. The DIS-1859 redline's tokenGaps verdict for
 * 1312 / 1288: "new token proposal: recurs on header, dropdown and footer". Upgrade path:
 * layout.desktop.contentMax 1312, panel = contentMax − 24.
 */
export const CONTENT_MAX_WIDTH = 1312;
/** 1440 at the Figma desktop frame: the content column plus its two 64 insets. */
export const PAGE_MAX_WIDTH = CONTENT_MAX_WIDTH + 2 * space.s64;
export const PANEL_WIDTH = CONTENT_MAX_WIDTH - space.s24;
/**
 * The desktop-class nav row, centred in the content column.
 *
 * SHORTCUT: layout literal with no token. Upgrade path: a DIS-1735 layout token.
 */
export const NAV_ROW_WIDTH = 972;

export type Band = 'mobile' | 'tablet' | 'desktop' | 'wide';

export const bandFor = (width: number): Band =>
  width >= breakpoints.wideMin
    ? 'wide'
    : width >= breakpoints.desktopMin
      ? 'desktop'
      : width >= breakpoints.tabletMin
        ? 'tablet'
        : 'mobile';

/** The header band for the current window width. */
export const useBand = (): Band => bandFor(useWindowDimensions().width);
